let instance;
class ApiUrl {
  constructor() {
    if (!instance) {
      this.baseInit();
      this.youtubeInit();
      this.adminInit();
      // this.helpCenterInit();
      this.v2Init();
      instance = this;
    }

    return instance;
  }

  baseInit() {
    if (!instance) {
      this.base = {
        login: "/login",
        homepages: "/api/page/homePages.html",
        subpages: "/api/page/subPages.html",
        productpages: "/api/page/productPages.html",
        collectionpages: "/api/page/collectionPages.html",
        articlepages: "/api/page/articlePages.html",
        recentPage: "/api/page/recentPages.html",
        newPage: "/api/page/newPage.html",
        fetchPreviewLink: "/api/pages/get-batch-preview-url",
        search: "/api/shop/search",
        shareLibrary: id => `/api/shared/l/${id}`,
        page: {
          deletePage: "/api/page/deletePage.html",
          updatePage: "/api/page/updatePage.html",
          makeDefault: "/api/page/makeDefault.html",
          searchPage: "/api/page/search.html",
          assignGroup: "/api/page/assignGroup.html",
          linkPage: id => `api/page/linkPage/${id}`,
          unlinkPage: id => `api/page/unlink/${id}`,
          duplicateTo: "/api/pages/duplicate-to",
          getDashboard: "/api/dashboard/get",
          putDashboardSettings: "/api/dashboard/update-settings",
          makeDefault20: "/api/pages/make-default",
          modifyLayout: "/api/page/article/modify-layout"
        },
        template: {
          allTemplates: "/api/template/allTemplates.html",
          import: `/api/library/share/import`,
          view: id => `/api/template/view/${id}`,
          checkDomainShareLibrary: '/api/library/share/check_domain_share_library'
        },
        assignment: {
          productpages: "/api/product/getProductsByIds.html",
          collectionpages: "/api/collection/getCollectionsByIds.html",
          shopMeta: "api/shop/getShopMeta.html",
          get: {
            productpages: "/api/product/getAssignedProducts.html",
            collectionpages: "/api/collection/getAssignedCollections.html"
          },
          assign: {
            productpages: "/api/product/assignProductTemplate.html",
            collectionpages: "/api/collection/assignCollectionTemplate.html"
          },
          all: {
            productpages: "/api/product/getProducts.html",
            collectionpages: "/api/collection/getCollections.html"
          },
          search: {
            productpages: "/api/product/searchProducts.html",
            collectionpages: "/api/collection/searchCollections.html"
          }
        },
        newAssignment: {
            getBy: {
              all: "/api/product/getAllProducts",
              pages: {
                list: 'api/product/getListProductPage',
                products: '/api/product/getProductsByProductPage'
              },
              collections: {
                list: '/api/product/getListShopifyCollection',
                products: '/api/product/getProductsByShopifyCollection'
              },
            },
            updatePageAssignment: pageId =>  `/api/pages/${pageId}/page-assignment`,
            // getLastestProduct: "/api/product2/getLatestProduct",
            // getAssignedProduct: "/api/product2/getAssignedProducts"
        },
        downgrade: {
          productpages: "/api/downgrade/productPages.html",
          articlepages: "/api/downgrade/articlePages.html",
          unpublish: "/api/page/unpublish"
        },
        group: {
          list: "/api/groups",
          get: "/api/groups/group-1",
          create: "/api/groups",
          update: id => `/api/groups/${id}`,
          delete: id => `/api/groups/${id}`
        },
        account: {
          updateInfo: "api/shop/updateShopinfo.html",
          updateAccount: "/api/shops/me/account",
          updateStore: "/api/shops/me/store",
          whoAmI: "api/admin/me",
          unlinkAgency: "api/shops/unlinkAgency",
          closeTrialSurvey: "/api/shops/me/extras",
          paymentInfo: "/api/payment/info",
          updateScriptInjector: "/api/admin/update-injector"
        },
        onboardingStep: {
          surveyInfo: "api/surveys"
        },
        newonboarding: {
          widgetSurvey: "api/surveys"
        },
        systemSetting: {
          getHelp: "/api/system-settings/get-help"
        },
        agency: {
          shopList: "api/agency/getShopList.html",
          register: "api/agency/register",
          login: "api/agencyLogin.html",
          loginShop: id => `api/agency/loginShop?shop_id=${id}`,
          forgot: "/agency/password",
          forgotPassword: "/agency/forgot-password",
          resetPassword: "agency/password",
          me: () => {
            var rand = new Date().getTime();
            return `api/agency/me?t=${rand}`;
          },
          addShop: "login",
          unlink: shop => `api/agency/unlinkShop/${shop.id}`,
          updateAgencyInfo: "api/agency/updateInfo",
          updatePassword: "api/agency/updatePassword",
          signout: `agency/sign_out`,
          isLinked: shop_id => `api/agency/isLinked?shop_domain=${shop_id}`,
          uploadImage: "api/agency/uploads"
        },
        category: {
          thirdParty: "/api/categories/thirdparty/snippets"
        },
        notification: {
          noti_list: "api/notification/user_noti/noti_list",
          noti_list_load: offset => `api/notification/user_noti/noti_list_load?offset=${offset}`,
          dismiss: id => `api/notification/user_noti/dismiss/${id}`,
          read: id => `api/notification/user_noti/read/${id}`,
          pin: id => `api/notification/user_noti/pin/${id}`,
          unpin: id => `api/notification/user_noti/unpin/${id}`,
          action: id => `api/notification/user_noti/action/${id}`,
          markAllRead: "api/notification/user_noti/read_all"
        },
        sections: {
          get: "api/sections/get"
        },
        analytic: {
          listCampaigns: "/api/campaigns",
          createCampaign: "/api/campaigns",
          startCampaign: id => `/api/campaigns/${id}/start`,
          stopCampaign: id => `/api/campaigns/${id}/stop`,
          campaignRUD: id => `/api/campaigns/${id}`,
          report: id => `/api/campaigns/${id}/report`,
          getVariants: `/api/campaigns/variants`,
          addVariants: id => `/api/campaigns/${id}/variants`,
          variantRUD: (id, pageID) => `/api/campaigns/${id}/variants/${pageID}`,
          clone: (id, pageID) => `/api/campaigns/${id}/variants/${pageID}/clone`,
          auth: "/api/analytics/auth",
          disconnect: "/api/analytics/disconnect",
          getAccounts: "/api/analytics/google/accounts",
          getProperties: id => `/api/analytics/google/accounts/${id}/webproperties`,
          getPropertiesGA4: id => `/api/analytics/google/accounts/${id}/webproperties?gaType=GA4`,
          getProfiles: (accountID, propertyID) => `/api/analytics/google/accounts/${accountID}/webproperties/${propertyID}/profiles`,
          getStreams: (accountID, propertyID) => `/api/analytics/google/accounts/${accountID}/webproperties/${propertyID}/streams`
        },
        eventLog: {
          associatedUsers: "/api/shops/associated-users",
          logs: "/api/shops/logs",
        },
        v2: {
          clonePage: "/api/v2/pages/clone",
        },
        newOnboarding: {
          productTaxonomy: "/api/misc/shopify-product-taxonomy"
        },
        pricing: {
          get: {
            content: '/api/dynamic/content',
            trigger: '/api/dynamic/trigger',
            payment: '/api/v2/payment/info'
          }
        },
        uninstall: '/api/shop/uninstall'
      };
    }

    return this.base;
  }

  youtubeInit() {
    if (!instance) {
      this.youtube = {
        playlist: (id, key) => `/playlistItems?part=snippet&maxResults=50&playlistId=${id}&key=${key}`,
        playlists: (key = "AIzaSyAa8yy0GdcGPHdtD083HiGGx_S0vMPScDM") => `/playlists?channelId=UCRUP8zvEDtEJrRtqCjbLJ0w&part=snippet%2CcontentDetails&maxResults=50&key=${key}`,
        video: (id, key) => `/videos?part=snippet,statistics&id=${id}&key=${key}`
      };
    }

    return this.youtube;
  }

  helpCenterInit() {
    if (!instance) {
      this.helpCenter = {
        articles: `/api/client/search`
      };
    }
  }

  adminInit() {
    if (!instance) {
      this.admin = {
        crud: "/api/i18n",
      };
    }

    return this.admin;
  }

  v2Init() {
    if (!instance) {
      this.v2 = {
        updatePage: "/api/v2/pages/update-page"
      };
    }

    return this.v2;
  }
}

export default new ApiUrl();
